export const MY_TEAM_ADD_USER = "MY_TEAM_ADD_USER";
export const MY_TEAM_ALL_ROLES = "MY_TEAM_ALL_ROLES";
export const MY_TEAM_ADD_USER_SUCCESSFUL = "MY_TEAM_ADD_USER_SUCCESSFUL";
export const MY_TEAM_ADD_USER_FAILED = "MY_TEAM_ADD_USER_FAILED";
export const MY_TEAM_ALL_ROLES_SUCCESSFUL = "MY_TEAM_ALL_ROLES_SUCCESSFUL";